module.exports = __webpack_public_path__ + "images/8bca604ffc10235d6d55d21de72832fa.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/october-logo.svg
// module id = 1055
// module chunks = 0